import type { TeamMember } from '@/types/doctor'

export const drMeena: TeamMember = {
  id: 1,
  name: 'Meena Gnanashekharan',
  displayName: 'Dr. Meena',
  title: 'Board-Certified Psychiatrist, CEO & Medical Director',
  role: 'Psychiatrist',
  credentials: ['KMC- 92604', 'ABPN ID - 168481'],
  imageUrl: '/images/team/drMeena.avif',
  specialty: 'Child, Adolescent & Adult Psychiatry',
  yearsExperience: 30,

  expertise: {
    children: ['ADHD'],
    adults: ['Mood Disorders', 'Anxiety Disorders', 'Integrative Psychiatry'],
  },

  languagesKnown: ['English', 'Hindi', 'Tamil'],

  education: [
    'Medical School M.B.B.S at Madras Medical College, Chennai, India.',
    'Adult Psychiatry Residency at University of South Dakota School Of Medicine, Sioux Falls, South Dakota, USA',
    'Child and Adolescent Psychiatry Fellowship, University of South Dakota School Of Medicine',
  ],
  bio: 'Dr. Meena is an American Board Certified Psychiatrist, practicing Child, Adolescent and Adult Psychiatry. She specializes in the treatment of Mood Disorders (Major Depressive disorders and the Bipolar Spectrum), and Anxiety Disorders (including phobias, OCD, Social Anxiety disorders). She combines her knowledge and experience with empathy and applies an integrative model of treating the mind, body and spirit for optimal effectiveness. She is passionate about Behavioural Health and helping people get access to the treatment and care that they need. She places a lot of importance on holistic treatments. She focuses equally on pharmacological interventions, psychotherapy and counselling as well as other alternative treatments.',
  philosophy:
    'I believe in treating the whole person, not just symptoms. By combining evidence-based medicine with compassionate care, we can help our patients achieve lasting wellness.',
  publications: [
    'Dr. Meena has been involved in research, education, and has presented papers at national and international platforms. Her research has been primarily in the areas of post-partum depression, anxiety disorders, and most recently the effects of Transcranial Magnetic Stimulation on mood and focus.',
  ],
}
